import { render, staticRenderFns } from "./pinzhongList.vue?vue&type=template&id=050f46a4&scoped=true&"
import script from "./pinzhongList.vue?vue&type=script&lang=js&"
export * from "./pinzhongList.vue?vue&type=script&lang=js&"
import style0 from "./pinzhongList.vue?vue&type=style&index=0&id=050f46a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f46a4",
  null
  
)

export default component.exports